// import axios from "axios";
import axios from "axios";
import { getUrl } from "@/common/config";

export default class machineEnvironmentalSensorsApi {
  constructor() {
    this.url = getUrl();
  }

  getSensorData(machineId, search) {
    return axios
      .get(`${this.url}/api/machines/${machineId}/sensordata`, { params: search })
      .then(response => {
        return response.data;
      });
  }
}
